import type { GeneratedFile } from '@cli-types/core-engine/schema.js'
import { formatContentForSnapshotMerge } from '@next-adapter/snapshots/format-for-merge/format-content-for-snapshot-merge.js'

export function buildMergeInput(
  cwd: string,
  baseFile: GeneratedFile,
  localContent: string,
  remoteFile: GeneratedFile
): { baseFile: GeneratedFile; localContent: string; remoteFile: GeneratedFile } {
  const formattedBase = formatContentForSnapshotMerge(cwd, remoteFile.path, baseFile.content)
  if (formattedBase == null) {
    return { baseFile, localContent, remoteFile }
  }

  const formattedLocal = formatContentForSnapshotMerge(cwd, remoteFile.path, localContent)
  const formattedRemote = formatContentForSnapshotMerge(cwd, remoteFile.path, remoteFile.content)
  if (formattedLocal == null || formattedRemote == null) {
    return { baseFile, localContent, remoteFile }
  }

  return {
    baseFile: {
      path: remoteFile.path,
      content: formattedBase
    },
    localContent: formattedLocal,
    remoteFile: {
      path: remoteFile.path,
      content: formattedRemote
    }
  }
}
